module.exports = __webpack_public_path__ + "static-m/img/banner.39a5f5af.png";